<template>
    <div>
        <div class="content-caption dashed">调整前</div>
        <div class="simple-form col-2 flex label">
            <div class="form-group center">
                <div class="form-label">
                    <label>总数量</label>
                </div>
                <div class="form-value">
                    <span>{{row.quantity || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>不良品数量</label>
                </div>
                <div class="form-value">
                    <span>{{row.defectQuantity || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>良品数量</label>
                </div>
                <div class="form-value">
                    <span>{{row.normalQuantity || 0}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">调整</div>
        <div class="simple-form col-2 flex label">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">增加</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="defectFlag" @change="selectDefectFlag" class="inline-block">
                        <el-radio :label="true">不良品</el-radio>
                        <el-radio :label="false">良品</el-radio>
                    </el-radio-group>

                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">数量</label>
                </div>
                <div class="form-value">
                    <el-input class="inline-block width-1x" v-model="quantity" type="number" min="0" @change="changeNormalQuantity"></el-input>
                    <div class="inline-block">{{row.unit || ''}}</div>
                </div>
            </div>
            <div class="form-group center" v-if="row.specificFlag">
                <div class="form-value">
                    <a class="font-blue" @click="doCreateSpecific()">个体配件({{specificAccList.length}})</a>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">调整后</div>
        <div class="simple-form col-2 flex label ">
            <div class="form-group center">
                <div class="form-label">
                    <label>总数量</label>
                </div>
                <div class="form-value">
                    <span>{{row.quantity || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>不良品数量</label>
                </div>
                <div class="form-value">
                    <span>{{adjustedDefectQuantity || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>良品数量</label>
                </div>
                <div class="form-value">
                    <span>{{adjustedNormalQuantity || 0}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">其他</div>
        <div class="simple-form label">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">备注</label>
                </div>
                <div class="form-value width-2x">
                    <el-input type="textarea" v-model="memo"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { selectSpecificAccSelectDlog } from '../accStock/selectDlg'
    export default {
        name: 'swb-stock-quantity-change',
        props: ["row"],
        data: function () {
            return {
                defectFlag: true,
                quantity: 0,
                memo: null,
                adjustedDefectQuantity: 0,
                adjustedNormalQuantity: 0,
                specificAccList: [],
                adjustedPage: 2
            }
        },
        created: function () {
            this.adjustedDefectQuantity = Utils.isNoB(this.row.defectQuantity) ? 0 : this.row.defectQuantity;
            this.adjustedNormalQuantity = Utils.isNoB(this.row.normalQuantity) ? 0 : this.row.normalQuantity;
        },
        methods: {
            // 正常数量转不良品数量，必须正常数量为正整数
            changeNormalQuantity: function () {
                let self = this;
                let row = self.row;
                let quantity = self.quantity;
                if(quantity <= 0) {
                    MsgBox.warning("请输入正确的数量");
                    return;
                }
                let adjustedDefectQuantity = this.adjustedDefectQuantity;
                let adjustedNormalQuantity = this.adjustedNormalQuantity;
                if(Utils.isTrue(self.defectFlag)) {
                    let defectQuantity = Utils.isNoB(this.row.defectQuantity) ? 0 : this.row.defectQuantity;
                    adjustedDefectQuantity = parseInt(defectQuantity) + parseInt(quantity);
                    if(row.quantity < adjustedDefectQuantity) {
                        MsgBox.warning("调整后的不良品数量不可大于总数量");
                        return;
                    }
                    adjustedNormalQuantity = parseInt(row.quantity) - parseInt(adjustedDefectQuantity);
                } else {
                    let normalQuantity = Utils.isNoB(this.row.normalQuantity) ? 0 : this.row.normalQuantity;
                    adjustedNormalQuantity = parseInt(normalQuantity) + parseInt(quantity);
                    if(row.quantity < adjustedNormalQuantity) {
                        MsgBox.warning("调整后的良品数量不可大于总数量");
                        return;
                    }
                    adjustedDefectQuantity = parseInt(row.quantity) - parseInt(adjustedNormalQuantity);
                }
                this.adjustedNormalQuantity = adjustedNormalQuantity;
                this.adjustedDefectQuantity = adjustedDefectQuantity;
            },
            selectDefectFlag: function () {
                let self = this;
                let row = self.row;
                let quantity = self.quantity;
                let adjustedDefectQuantity = this.adjustedDefectQuantity;
                let adjustedNormalQuantity = this.adjustedNormalQuantity;
                if(Utils.isTrue(self.defectFlag)) {
                    let defectQuantity = Utils.isNoB(this.row.defectQuantity) ? 0 : this.row.defectQuantity;
                    adjustedDefectQuantity = parseInt(defectQuantity) + parseInt(quantity);
                    if(row.quantity < adjustedDefectQuantity) {
                        MsgBox.warning("调整后的不良品数量不可大于总数量");
                        return;
                    }
                    this.adjustedPage = 2;
                    adjustedNormalQuantity = parseInt(row.quantity) - parseInt(adjustedDefectQuantity);
                } else {
                    let normalQuantity = Utils.isNoB(this.row.normalQuantity) ? 0 : this.row.normalQuantity;
                    adjustedNormalQuantity = parseInt(normalQuantity) + parseInt(quantity);
                    if(row.quantity < adjustedNormalQuantity) {
                        MsgBox.warning("调整后的良品数量不可大于总数量");
                        return;
                    }
                    this.adjustedPage = 1;
                    adjustedDefectQuantity = parseInt(row.quantity) - parseInt(adjustedNormalQuantity);
                }
                this.adjustedNormalQuantity = adjustedNormalQuantity;
                this.adjustedDefectQuantity = adjustedDefectQuantity;
            },
            doCreateSpecific: function () {
                let self = this;
                let accStock = self.row;
                let accId = accStock.accId;
                let specificAccList = self.specificAccList || [];
                let selectIds = specificAccList.pluck("id");
                let defectFlag = 1;
                if(Utils.isTrue(self.defectFlag)) {
                    defectFlag = 0;
                }
                //
                let filter = {
                    retailerComIdIsNull: true,
                    servicerWarehouseId: accStock.warehouseId,
                    servicerId: accStock.servicerId,
                    accId: accId,
                    shareAccFlag: true,
                    scrapFlag: false,
                    inUse: false,
                    clearedFlag: 0,
                    defectFlag: defectFlag,
                    failedFlag: 0,
                    includeHolderFlag: true,
                    repairingFlag: 0,
                    retailerOwned: false,
                    scrapped: 0

                };

                let postData = {
                    filter: filter,
                    checkBox: true,
                    selectIds: selectIds
                };
                //
                selectSpecificAccSelectDlog(postData, function (result, theDlg) {

                    theDlg.close();
                    self.specificAccList = Utils.merge([], result);
                })
            },
            getDlgResult: function () {
                let result = {};
                let self = this;
                let warnFlag = false;
                if(self.quantity <= 0) {
                    result.type = "warn";
                    result.message = "请输入正确的数量";
                    warnFlag = true;
                }
                if(Utils.isTrue(self.defectFlag)) {
                    if(self.row.quantity < self.adjustedDefectQuantity) {
                        result.type = "warn";
                        result.message = "调整后的不良品数量不可大于总数量";
                        warnFlag = true;
                    }
                } else {
                    if(self.row.quantity < self.adjustedNormalQuantity) {
                        result.type = "warn";
                        result.message = "调整后的良品数量不可大于总数量";
                        warnFlag = true;
                    }
                }
                if(Utils.isTrue(self.row.specificFlag)) {
                    if(self.specificAccList.length <= 0) {
                        result.type = "warn";
                        result.message = "请选择个体配件";
                        warnFlag = true;
                    } else if(self.specificAccList.length != self.quantity) {
                        result.type = "warn";
                        result.message = "数量与个体配件数量不匹配";
                        warnFlag = true;
                    }
                }
                if(Utils.isFalse(warnFlag)) {
                    let postData = {
                        defectQuantity: self.adjustedDefectQuantity,
                        normalQuantity: self.adjustedNormalQuantity,
                        memo: self.memo,
                        specificAccList: self.specificAccList,
                        adjustedPage: self.adjustedPage,
                    };
                    result.type = "info";
                    result.data = postData;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shareAcc/StockQuantityChange.vue